import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/login',
    name: 'login',
    meta: { title: '登录' },
    component: () => import('../views/login')
  },
  {
    path: '/',
    name: 'home',
    meta: { title: '首页' },
    component: () => import('../views/home')
  },
  {
    path: '/notice',
    name: 'notice',
    meta: { title: '消息中心' },
    component: () => import('../views/notice')
  },
  {
    path: '/turnoverDetail',
    name: 'turnoverDetail',
    meta: { title: '营业额详情' },
    component: () => import('../views/turnoverDetail')
  },
  {
    path: '/logistics/:orderId/:type',
    name: 'logistics',
    meta: { title: '物流信息' },
    component: () => import('../views/logistics')
  },
  {
    path: '/cashApply',
    name: 'cashApply',
    meta: { title: '提现申请' },
    component: () => import('../views/cashApply')
  },
  {
    path: '/userAuth',
    name: 'userAuth',
    meta: { title: '用户认证' },
    component: () => import('../views/cashApply/userAuth')
  },
  {
    path: '/myCommunity',
    name: 'myCommunity',
    meta: { title: '我的社群' },
    component: () => import('../views/myCommunity')
  },
  {
    path: '/subCommunity/:selectUserId/:nickName',
    name: 'subCommunity',
    meta: { title: '我的下级社群' },
    component: () => import('../views/subCommunity')
  },
  {
    path: '/setting',
    name: 'setting',
    meta: { title: '设置' },
    component: () => import('../views/setting')
  },
  {
    path: '/setIdCard',
    name: 'setIdCard',
    meta: { title: '身份证绑定' },
    component: () => import('../views/setIdCard')
  },
/*  {
    path: '/addressList',
    name: 'addressList',
    meta: { title: '选择地址'  },
    component: () => import('../views/addressList')
  },
  {
    path: '/addAddress',
    name: 'addAddress',zh
    meta: { title: '添加地址' },
    component: () => import('../views/addAddress')
  },*/
  {
    path: '/orderDetail/:orderId',
    name: 'orderDetail',
    meta: { title: '订单详情' },
    component: () => import('../views/orderDetail')
  },
  {
    path: '/chargeList',
    name: 'chargeList',
    meta: { title: '充值记录' },
    component: () => import('../views/chargeList')
  },
  {
    path: '/poster',
    name: 'poster',
    meta: { title: '我的海报' },
    component: () => import('../views/poster')
  },
  {
    path: '/luckDraw/:luckDrawId',
    name: 'luckDraw',
    meta: { title: '抽奖' },
    component: () => import('../views/luckDraw')
  },
  {
    path: '/winningRecord',
    name: 'winningRecord',
    meta: { title: '中奖记录' },
    component: () => import('../views/winningRecord')
  },
  {
    path: '/receiveAward',
    name: 'receiveAward',
    meta: { title: '领取奖品' },
    component: () => import('../views/receiveAward')
  },
  {
    path: '/scoreList',
    name: 'scoreList',
    meta: { title: '我的积分' },
    component: () => import('../views/scoreList')
  },
  {
    path: '/private',
    name: 'private',
    meta: { title: '糖pai服务协议' },
    component: () =>import('../views/private')
  },
  {
    path: '/transferSelect',
    name: 'transferSelect',
    meta: { title: '购物金转账选择' },
    component: () => import('../views/transferSelect')
  },
  {
    path: '/transferList',
    name: 'transferList',
    meta: { title: '购物车转账记录' },
    component: () => import('../views/transferSelect/transferList')
  },
  {
    path: '/bank',
    name: 'bank',
    meta: { title: '银行卡管理' },
    component: () => import('../views/bank')
  }
]

const router = new VueRouter({
  mode: 'history',
  routes,
})

export default router
